/**
 * カテゴリセレクトのカスタムドロップダウン
 */

export const initCategorySelect = () => {
  const customSelects = document.querySelectorAll('.jsFormPullDown');
  
  customSelects.forEach(customSelect => {
    const selectId = customSelect.getAttribute('data-select-id');
    const selectElement = document.getElementById(selectId);
    
    if (!selectElement) {
      return;
    }
    
    setupCustomSelect(customSelect, selectElement);
  });
};

function setupCustomSelect(customSelect, selectElement) {
  const button = customSelect.querySelector('.modFormPullDown__btn');
  const list = customSelect.querySelector('.modFormPullDown__list');
  const items = list.querySelectorAll('.item');
  const selectedText = button.querySelector('.selectedText');
  let closeTransitionHandler = null;
  let openTransitionHandler = null;
  let highlightedIndex = -1;
  
  // 必要な要素が存在するかチェック
  if (!button || !list || !selectedText) {
    return;
  }
  
  if (!customSelect.classList.contains('is-open')) {
    list.hidden = true;
  }
  
  button.addEventListener('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    toggleDropdown();
  });
  
  items.forEach((item, index) => {
    item.addEventListener('click', (e) => {
      e.stopPropagation();
      selectOption(item, index);
    });
  });
  
  button.addEventListener('keydown', (e) => {
    handleKeyDown(e);
  });
  
  document.addEventListener('click', (e) => {
    if (!customSelect.contains(e.target) && customSelect.classList.contains('is-open')) {
      closeDropdown();
    }
  });
  
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && customSelect.classList.contains('is-open')) {
      closeDropdown();
      button.focus();
    }
  });
  
  function openDropdown() {
    // 既存のハンドラーをクリーンアップ
    if (closeTransitionHandler) {
      list.removeEventListener('transitionend', closeTransitionHandler);
      closeTransitionHandler = null;
    }
    if (openTransitionHandler) {
      list.removeEventListener('transitionend', openTransitionHandler);
      openTransitionHandler = null;
    }
    
    // hidden属性を削除（CSSの優先順位を考慮して先に削除）
    list.removeAttribute('hidden');
    // 閉じるアニメーション用のクラスを削除
    list.classList.remove('is-closing');
    button.setAttribute('aria-expanded', 'true');
    
    // アニメーション中はoverflow-y: hiddenにして、スクロールバーを非表示にする
    // display: block !important を設定して、hidden属性の影響を確実に解除
    list.style.overflowY = 'hidden';
    list.style.overflowX = 'hidden';
    list.style.display = 'block';
    list.style.setProperty('display', 'block', 'important');
    list.style.opacity = '0';
    list.style.maxHeight = '0';
    
    // requestAnimationFrameを2回使用して、ブラウザがdisplay: blockを適用してから
    // max-heightのアニメーションを開始するようにする
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        customSelect.classList.add('is-open');
        list.style.opacity = '';
        list.style.maxHeight = '';
        
        // アニメーション完了後にoverflow-y: autoを適用（CSSの値を使用）
        openTransitionHandler = (event) => {
          // max-heightまたはopacityのトランジションが完了したときのみ処理
          if (event.propertyName !== 'max-height' && event.propertyName !== 'opacity') return;
          if (event.target !== list) return;
          if (customSelect.classList.contains('is-open')) {
            // インラインスタイルを削除してCSSのoverflow-y: autoを適用
            list.style.overflowY = '';
            list.style.overflowX = '';
            list.style.display = '';
            list.style.opacity = '';
            list.style.maxHeight = '';
          }
          list.removeEventListener('transitionend', openTransitionHandler);
          openTransitionHandler = null;
        };
        list.addEventListener('transitionend', openTransitionHandler);
      });
    });
    
    const selectedItem = list.querySelector('.is-selected');
    if (selectedItem) {
      highlightedIndex = Array.from(items).indexOf(selectedItem);
    } else {
      highlightedIndex = selectElement.selectedIndex >= 0 ? selectElement.selectedIndex : 0;
    }
  }
  
  function closeDropdown() {
    if (!customSelect.classList.contains('is-open')) {
      return;
    }
    
    // 既存のハンドラーをクリーンアップ
    if (openTransitionHandler) {
      list.removeEventListener('transitionend', openTransitionHandler);
      openTransitionHandler = null;
    }
    if (closeTransitionHandler) {
      list.removeEventListener('transitionend', closeTransitionHandler);
      closeTransitionHandler = null;
    }
    
    // 閉じる前にoverflow-yをhiddenに戻す（アニメーション中はスクロールバーを非表示）
    list.style.overflowY = 'hidden';
    list.style.overflowX = 'hidden';
    
    // 閉じるアニメーションを開始
    // まず、is-closingクラスを追加してアニメーションを開始
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        list.classList.add('is-closing');
        button.setAttribute('aria-expanded', 'false');
        highlightedIndex = -1;
        
        // アニメーション完了後にクラスを削除し、hidden属性を追加
        closeTransitionHandler = (event) => {
          // max-heightまたはopacityのトランジションが完了したときのみ処理
          if (event.propertyName !== 'max-height' && event.propertyName !== 'opacity') return;
          if (event.target !== list) return;
          
          // アニメーション完了後の処理
          list.classList.remove('is-closing');
          customSelect.classList.remove('is-open');
          list.setAttribute('hidden', '');
          list.style.overflowY = '';
          list.style.overflowX = '';
          list.style.display = '';
          list.style.opacity = '';
          list.style.maxHeight = '';
          list.removeEventListener('transitionend', closeTransitionHandler);
          closeTransitionHandler = null;
        };
        
        list.addEventListener('transitionend', closeTransitionHandler);
      });
    });
  }
  
  function toggleDropdown() {
    if (customSelect.classList.contains('is-open')) {
      closeDropdown();
    } else {
      openDropdown();
    }
  }
  
  function selectOption(item, index) {
    const value = item.getAttribute('data-value') || '';
    const textSpan = item.querySelector('span');
    const text = textSpan ? textSpan.textContent.trim() : item.textContent.trim();
    
    // selectElementの対応するoptionを探す
    const options = Array.from(selectElement.options);
    const optionIndex = options.findIndex(opt => opt.value === value);
    
    if (optionIndex >= 0) {
      selectElement.selectedIndex = optionIndex;
      selectElement.value = value;
    } else {
      selectElement.selectedIndex = index;
      selectElement.value = value;
    }
    
    items.forEach(i => {
      i.classList.remove('is-selected');
      i.setAttribute('aria-selected', 'false');
    });
    item.classList.add('is-selected');
    item.setAttribute('aria-selected', 'true');
    
    selectedText.textContent = text;
    
    closeDropdown();
    button.focus();
    
    const event = new Event('change', { bubbles: true });
    selectElement.dispatchEvent(event);
  }
  
  function handleKeyDown(e) {
    let currentIndex = highlightedIndex >= 0 ? highlightedIndex : selectElement.selectedIndex;
    
    switch(e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (!customSelect.classList.contains('is-open')) {
          openDropdown();
        } else {
          currentIndex = Math.min(currentIndex + 1, items.length - 1);
          updateHighlight(currentIndex);
        }
        break;
        
      case 'ArrowUp':
        e.preventDefault();
        if (customSelect.classList.contains('is-open')) {
          currentIndex = Math.max(currentIndex - 1, 0);
          updateHighlight(currentIndex);
        }
        break;
        
      case 'Enter':
      case ' ':
        e.preventDefault();
        if (customSelect.classList.contains('is-open') && highlightedIndex >= 0 && items[highlightedIndex]) {
          selectOption(items[highlightedIndex], highlightedIndex);
        } else {
          openDropdown();
        }
        break;
        
      case 'Home':
        e.preventDefault();
        if (customSelect.classList.contains('is-open')) {
          updateHighlight(0);
        }
        break;
        
      case 'End':
        e.preventDefault();
        if (customSelect.classList.contains('is-open')) {
          updateHighlight(items.length - 1);
        }
        break;
    }
  }
  
  function updateHighlight(index) {
    highlightedIndex = index;
    if (items[index]) {
      items[index].scrollIntoView({ block: 'nearest' });
    }
  }
}
